import React from 'react';
import { useTranslation } from 'react-i18next';
import Typography from '@mui/material/Typography';
import Breadcrumbs from '@mui/material/Breadcrumbs';
import { Col, Container, Row } from 'react-bootstrap';
import Manager from './Manager';



const UsersManagement = () => (
  <div>
    <Breadcrumbs
      style={{ marginLeft: '20px', marginBottom: '15px' }}
      aria-label="breadcrumb"
    >
      <Typography sx={{ color: 'text.primary' }}>Restaurant</Typography>
      <Typography sx={{ color: 'text.primary' }}>User Manager</Typography>
      <Typography sx={{ color: 'text.primary' }}>User Management</Typography>
    </Breadcrumbs>
    <Container>
      <Manager />
    </Container>
  </div>

  );

export default UsersManagement;
